import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { RoleForm } from "@/components/forms/RoleForm";
import { useThemeColors } from "@/hooks/useThemeColors";

export default function CreateRolePage() {
  const colors = useThemeColors();
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/user-management/roles");
  };

  const handleCancel = () => {
    navigate("/user-management/roles");
  };

  return (
    <AdminLayout>
      <Box bg="#FEFCF8" minH="100vh" p={4}>
        <VStack spacing={4} align="stretch" flex="1" minH="100vh">
          {/* Header Section */}
          <Box>
            <Heading size="md">Create New Role</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Create a new role and assign permissions
            </Text>
          </Box>

          {/* Form Section */}
          <Box flex="1" overflow="auto">
            <RoleForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </Box>
        </VStack>
      </Box>
    </AdminLayout>
  );
}
